var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVtmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11719 6.89258C5.42886 6.89258 6.49219 5.82925 6.49219 4.51758C6.49219 3.2059 5.42886 2.14258 4.11719 2.14258C2.80551 2.14258 1.74219 3.2059 1.74219 4.51758C1.74219 5.82925 2.80551 6.89258 4.11719 6.89258Z",
    stroke: "#002060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1953 12.4346C16.507 12.4346 17.5703 11.3712 17.5703 10.0596C17.5703 8.74789 16.507 7.68457 15.1953 7.68457C13.8836 7.68457 12.8203 8.74789 12.8203 10.0596C12.8203 11.3712 13.8836 12.4346 15.1953 12.4346Z",
    stroke: "#002060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11719 17.9766C5.42886 17.9766 6.49219 16.9132 6.49219 15.6016C6.49219 14.2899 5.42886 13.2266 4.11719 13.2266C2.80551 13.2266 1.74219 14.2899 1.74219 15.6016C1.74219 16.9132 2.80551 17.9766 4.11719 17.9766Z",
    stroke: "#002060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8255 10.0592H7.28385C5.54219 10.0592 4.11719 9.26758 4.11719 6.89258V13.2259",
    stroke: "#002060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtmIcon);
export default __webpack_public_path__ + "static/media/VTM-icon.e11cf3089404ec228000d6a83ff0eb6b.svg";
export { ForwardRef as ReactComponent };